import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaginatorModule } from 'primeng/paginator';
import { AppModuleGlobalShared } from '../../../app.module.global';
import { CoreModule } from '../../core/core.module';
import { ExportadorEditComponent } from './exportadores/exportador-edit.component';
import { ExportadorListComponent } from './exportadores/exportador-list.component';
import { EntidadAuditoraListComponent } from './entidadesauditoras/entidadauditora-list.component';
import { EntidadAuditoraEditComponent } from './entidadesauditoras/entidadauditora-edit.component';
import { InstalacionEditComponent } from './instalaciones/instalacion-edit.component';
import { LaboratorioListComponent } from './laboratorios/laboratorio-list.component';
import { LaboratorioEditComponent } from './laboratorios/laboratorio-edit.component';
import { TecnicoLaboratorioEditComponent } from './laboratorios/tecnicolaboratorio-edit.component';
import { InstalacionListComponent } from './instalaciones/instalacion-list.component';
import { EntidadAuditoraService } from './entidadesauditoras/entidadauditora.service';
import { ExportadorService } from './exportadores/exportador.service';
import { InstalacionService } from './instalaciones/instalacion.service';
import { RegLaboratorioService } from './laboratorios/laboratorio.service';
import { TecnicoEntidadEditComponent } from './entidadesauditoras/tecnicoentidad-edit.component';
import { CampaniaEntidadEditComponent } from './entidadesauditoras/campaniaentidad-edit.component';
import { AgenteControlService } from './agentescontrol/agentecontrol.service';
import { AgenteControlListComponent } from './agentescontrol/agentecontrol-list.component';
import { AgenteControlEditComponent } from './agentescontrol/agentecontrol-edit.component';
import { AgenteControlCaEditComponent } from './agentescontrol/agentecontrolca-edit.component';
import { RegistrosRoutingModule } from './registros-routing.module';
import { CodigoConfeccionService } from './codigosconfeccion/codigoconfeccion.service';
import { CodigoconfeccionWrapperComponent } from './codigosconfeccion/codigoconfeccion-wrapper/codigoconfeccion-wrapper.component';
import { CodigoconfeccionFilterComponent } from './codigosconfeccion/codigoconfeccion-filter/codigoconfeccion-filter.component';
import { CodigoConfeccionListComponent } from './codigosconfeccion/codigoconfeccion-list/codigoconfeccion-list.component';
import { CodigoConfeccionEditComponent } from './codigosconfeccion/codigoconfeccion-edit/codigoconfeccion-edit.component';
import { CodigoconfeccionDetailDialogComponent } from './codigosconfeccion/codigoconfeccion-detail-dialog/codigoconfeccion-detail-dialog.component';
import { CodigoconfeccionListDialogComponent } from './codigosconfeccion/codigoconfeccion-list-dialog/codigoconfeccion-list-dialog.component';
import { RegistroSanitarioService } from './registrosanitario/registrosanitario.service';
import { RegistroSanitarioWrapperComponent } from './registrosanitario/registrosanitario-wrapper/registrosanitario-wrapper.component';
import { RegistroSanitarioFilterComponent } from './registrosanitario/registrosanitario-filter/registrosanitario-filter.component';
import { RegistroSanitarioListComponent } from './registrosanitario/registrosanitario-list/registrosanitario-list.component';
import { RegistroSanitarioWrapperEditComponent } from './registrosanitario/registrosanitario-wrapper-edit/registrosanitario-wrapper-edit.component';
import { RegistroSanitarioEditComponent } from './registrosanitario/registrosanitario-edit/registrosanitario-edit.component';
import { CodigoConfeccionDesautorizadoCamService } from './codigosconfeccion/codigoconfeccion-desautorizada-cam.service';

@NgModule({
    declarations: [
        ExportadorListComponent,
        ExportadorEditComponent,
        EntidadAuditoraListComponent,
        EntidadAuditoraEditComponent,
        CampaniaEntidadEditComponent,
        TecnicoEntidadEditComponent,
        InstalacionListComponent,
        InstalacionEditComponent,
        LaboratorioListComponent,
        LaboratorioEditComponent,
        TecnicoLaboratorioEditComponent,
        AgenteControlListComponent,
        AgenteControlEditComponent,
        AgenteControlCaEditComponent,
        CodigoConfeccionEditComponent,
        CodigoConfeccionListComponent,
        CodigoconfeccionWrapperComponent,
        CodigoconfeccionFilterComponent,
        CodigoconfeccionDetailDialogComponent,
        CodigoconfeccionListDialogComponent,
        RegistroSanitarioWrapperComponent,
        RegistroSanitarioFilterComponent,
        RegistroSanitarioListComponent,
        RegistroSanitarioWrapperEditComponent,
        RegistroSanitarioEditComponent,
    ],
    imports: [CoreModule, AppModuleGlobalShared, PaginatorModule, CommonModule, FormsModule, ReactiveFormsModule, RegistrosRoutingModule],
    providers: [
        CodigoConfeccionService,
        EntidadAuditoraService,
        ExportadorService,
        InstalacionService,
        RegLaboratorioService,
        AgenteControlService,
        RegistroSanitarioService,
        CodigoConfeccionDesautorizadoCamService,
    ],
    exports: [CodigoConfeccionListComponent, CodigoConfeccionEditComponent, CodigoconfeccionDetailDialogComponent, CodigoconfeccionListDialogComponent],
})
export class RegistrosModule {}
